import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { Formik, Field, Form as FormikForm, ErrorMessage } from 'formik';
import * as Yup from 'yup';

// constants
import { COLOR_WHITE, LINEAR_GRADIENT_BG } from '../../../constants';

// icons
import { MdClose, MdSave } from 'react-icons/md';

export default function ConfirmCOD({ isShipMentPaytype, setIsShipMentPayType, handleCloseCodModal }) {
    // Validation schema using Yup
    const validationSchema = Yup.object({
        fullName: Yup.string()
            .required('ກະລຸນາປ້ອນຊື່ລູກຄ້າ!'),
        phoneNumber: Yup.string()
            .matches(
                /^(020|030)[0-9]{6,9}$/,
                'ເບີໂທຕ້ອງເປີດດ້ວຍ 020 ຫຼື 030 ແລະຕ້ອງມີ 10-11 ຕົວເລກ'
            )
            .required('ກະລຸນາປ້ອນເບີໂທຕິດຕໍ່'),
        identityCard: Yup.string()
            .nullable(),
        remark: Yup.string()
            .required('ກະລຸນາປ້ອນໝາຍເຫດ ຫຼື ຄຳອະທິບາຍ!'),
    });


    const handleSubmit = (values) => {
        setIsShipMentPayType((prev) => ({
            ...prev,
            isOpenCod: false, // Close modal
            data: values, // Save form values to state
        }));
    };

    return (
        <React.Fragment>
            <Modal centered show={isShipMentPaytype?.isOpenCod} onHide={handleCloseCodModal}>
                <Modal.Header>
                    <Modal.Title>ຢືນຢັນຂໍ້ມູນລູກຄ້າ ເພື່ອດຳເນີນການ ເກັບປາຍທາງ (COD)</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={{
                        fullName: '',
                        phoneNumber: '',
                        identityCard: '',
                        remark: '',
                    }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ errors, touched }) => (
                        <FormikForm>
                            <Modal.Body>
                                <Form.Group className="mb-3" controlId="fullName">
                                    <Form.Label>ຊື່ລູກຄ້າ (ຕ້ອງປ້ອນ)</Form.Label>
                                    <Field
                                        name="fullName"
                                        className={`form-control ${touched.fullName && errors.fullName ? 'is-invalid' : ''
                                            }`}
                                        placeholder="ປ້ອນຊື່..."
                                    />
                                    <ErrorMessage
                                        name="fullName"
                                        component="div"
                                        className="invalid-feedback"
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="phoneNumber">
                                    <Form.Label>ເບີໂທຕິດຕໍ່ (ຕ້ອງປ້ອນ)</Form.Label>
                                    <Field
                                        name="phoneNumber"
                                        className={`form-control ${touched.phoneNumber && errors.phoneNumber
                                                ? 'is-invalid'
                                                : ''
                                            }`}
                                        placeholder="ປ້ອນເບີໂທ..."
                                    />
                                    <ErrorMessage
                                        name="phoneNumber"
                                        component="div"
                                        className="invalid-feedback"
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="identityCard">
                                    <Form.Label>ເລກບັດປະຈຳຕົວ (ຖ້າມີ)</Form.Label>
                                    <Field
                                        name="identityCard"
                                        className="form-control"
                                        placeholder="ປ້ອນເລກບັດ..."
                                    />
                                    <ErrorMessage
                                        name="identityCard"
                                        component="div"
                                        className="invalid-feedback"
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="remark">
                                    <Form.Label>ຄຳອະທິບາຍ (ຕ້ອງປ້ອນ)</Form.Label>
                                    <Field
                                        as="textarea"
                                        rows={3}
                                        name="remark"
                                        className="form-control"
                                        placeholder="ປ້ອນຄຳອະທິບາຍ..."
                                    />
                                    <ErrorMessage
                                        name="remark"
                                        component="div"
                                        className="invalid-feedback"
                                    />
                                </Form.Group>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="light" onClick={handleCloseCodModal}>
                                    <MdClose /> ຍົກເລີກ
                                </Button>
                                <Button
                                    type="submit"
                                    style={{
                                        background: LINEAR_GRADIENT_BG,
                                        color: COLOR_WHITE,
                                        border: 'none'
                                    }}
                                >
                                    <MdSave /> ບັນທຶກ
                                </Button>
                            </Modal.Footer>
                        </FormikForm>
                    )}
                </Formik>
            </Modal>
        </React.Fragment>
    );
}
